export default function Checkbox() {
  return {}
}
